module.exports = {"130503001":"钢铁路街道","130503002":"中兴路街道","130503003":"达活泉街道","130503004":"张宽街道","130503005":"章村街道","130503006":"中华大街街道","130503007":"团结路街道","130503008":"泉西街道","130503100":"南大郭镇","130503101":"李村镇","130503102":"南石门镇","130503103":"羊范镇","130503104":"皇寺镇","130503105":"会宁镇","130503106":"西黄村镇","130503107":"路罗镇","130503108":"将军墓镇","130503109":"浆水镇","130503110":"宋家庄镇","130503202":"太子井乡","130503203":"龙泉寺乡","130503204":"北小庄乡","130503205":"城计头乡","130503206":"白岸乡","130503207":"冀家村乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130503.json
// module id = 218
// module chunks = 0